import { urlGeneratorService } from './urlGeneratorService';

const DefaultExternalUrls = {
  genesysCloud: (id: string) => `https://apps.usw2.pure.cloud/directory/#/engage/admin/interactions/${id}`,
  spruceHelpLinkUrl: () =>
    `https://zillow.service-now.com/esc?id=emp_taxonomy_topic&topic_id=9d4cb682db168a10754ca6dc139619d0`,
};

export const ExternalUrlFactory = (baseUrl?: string) => urlGeneratorService({}, baseUrl).addUrl(DefaultExternalUrls);
export const externalUrls = ExternalUrlFactory();
